import React from 'react';
import './style.less';

interface Props {
  src: string
}

const KzFrame: React.FC<Props> = ({
  src
}) => (
  <iframe className="c-frame" src={`${src}`}></iframe>
)

export default KzFrame;